import apiClient from '@/shared/utils/apiConfig';

export type NotificationType =
  | 'appointment'
  | 'patient'
  | 'inventory'
  | 'payment'
  | 'treatment'
  | 'system'
  | 'reminder';

export type NotificationPriority = 'low' | 'medium' | 'high' | 'urgent';

export interface AppNotification {
  _id: string;
  title: string;
  message: string;
  type: NotificationType | string;
  priority: NotificationPriority | string;
  isRead: boolean;
  actionUrl?: string;
  createdAt: string;
  readAt?: string;
  event?: string;
}

export interface NotificationListParams {
  page?: number;
  limit?: number;
  read?: boolean;
  type?: string;
  priority?: string;
}

export interface NotificationListResponse {
  success: boolean;
  count: number;
  total: number;
  page: number;
  pages: number;
  data: AppNotification[];
}

export const getNotifications = async (
  params: NotificationListParams = {}
): Promise<NotificationListResponse> => {
  const { page = 1, limit = 20, read, type, priority } = params;
  const response = await apiClient.get<NotificationListResponse>('/notifications', {
    params: {
      page,
      limit,
      ...(read === undefined ? {} : { read: String(read) }),
      ...(type ? { type } : {}),
      ...(priority ? { priority } : {}),
    },
  });
  return response.data;
};

export const getUnreadCount = async (): Promise<{ success: boolean; count: number }> => {
  const response = await apiClient.get<{ success: boolean; count: number }>(
    '/notifications/unread-count'
  );
  return response.data;
};

export const markAsRead = async (notificationId: string) => {
  const response = await apiClient.put(`/notifications/${notificationId}/read`);
  return response.data;
};

export const markAllAsRead = async () => {
  const response = await apiClient.put('/notifications/mark-all-read');
  return response.data;
};

export const deleteNotification = async (notificationId: string) => {
  const response = await apiClient.delete(`/notifications/${notificationId}`);
  return response.data;
};
